export enum ALERTICON {
  ERR = "error",
  INFO = "info",
  SUCCESS = "success",
  WARN = "warning",
}
